import axios from 'axios'

const apiClient = axios.create({
//baseURL: `http://localhost:17823/`,
//baseURL: `https://fuldmagttestapi.gls.dk/`,
  baseURL: `https://fuldmagtapi.gls.dk/`,
  withCredentials: false,
  headers: { Accept: "application/json", "Content-Type": "application/json" }
});
export const SignerService = {
    async getsignerUrl(signer) {        
        return await apiClient.post('/signer/sign',signer);    
    },
    //Bruges ikke, men skal ikke slettes !!!
    async delete(orderId){
        return await apiClient.post('/signer/delete',{
            reference: orderId
        });
    }//
};
